import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, BookmarkSimple } from "@phosphor-icons/react";
import EventCard from "../../components/EventCard";
import { PageLoader, EmptyState } from "../../components/shared";
import { Button } from "../../components/ui/button";
import api from "../../lib/api";
import { useAutoRefresh } from "../../hooks/useAutoRefresh";
import { RefreshBar } from "../../components/RefreshBar";

export default function Saved() {
  const [tab, setTab] = useState("liked");
  const [liked, setLiked] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => Promise.all([api.get("/me/likes"), api.get("/me/wishlist")])
    .then(([l, w]) => { setLiked(l.data.events || []); setWishlist(w.data.events || []); })
    .finally(() => setLoading(false));
  const { refreshing, lastUpdated, refresh } = useAutoRefresh(load, []);

  const list = tab === "liked" ? liked : wishlist;

  return (
    <div className="mx-auto max-w-6xl px-4 md:px-6 py-8">
      <RefreshBar refreshing={refreshing} lastUpdated={lastUpdated} onRefresh={refresh} />
      <div className="overline mb-1">Your collection</div>
      <h1 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight mb-6">Saved Events</h1>

      <div className="flex gap-2 mb-6 p-1 rounded-full bg-muted w-fit">
        {[["liked", "Liked", Heart], ["wishlist", "Wishlist / Notify", BookmarkSimple]].map(([v, l, Icon]) => (
          <button key={v} onClick={() => setTab(v)} data-testid={`saved-tab-${v}`}
            className={`inline-flex items-center gap-1.5 px-4 h-9 rounded-full text-sm font-semibold transition-colors ${tab === v ? "bg-foreground text-background" : "text-muted-foreground"}`}>
            <Icon size={15} weight={tab === v ? "fill" : "regular"} /> {l}
          </button>
        ))}
      </div>

      {loading ? <PageLoader /> : list.length === 0 ? (
        <EmptyState icon={tab === "liked" ? Heart : BookmarkSimple}
          title={tab === "liked" ? "No liked events yet" : "Your wishlist is empty"}
          subtitle={tab === "liked" ? "Tap the heart on any event to save it here." : "Add sold-out or upcoming events to get notified."}
          action={<Button asChild className="rounded-full"><Link to="/discover">Explore events</Link></Button>}
          testid={`no-saved-${tab}`} />
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {list.map((e) => <EventCard key={e.id} event={e} />)}
        </div>
      )}
    </div>
  );
}
